import React from 'react'
import { Button, BUTTON_THEME, Icon, Input, Select } from '@st-operations/uikit/src/v2'

import { FIELD_LABELS, NAME_STEPS } from '../constants'

// Rework audience names before they are sent.
//
// Taxonomy names are full paths - "ShareThis > Auto > Trucks > Pickup" - and
// partners generally want something shorter or punctuated differently.
//
// The preview under the steps (name-preview.jsx) is what makes this usable:
// it shows the audiences this push will actually send, before and after.
// Without it you are editing blind, and these names end up in front of buyers.
const NameChanges = ({ value, onChange, disabled }) => {
  const steps = value || []

  const update = (index, patch) => {
    const next = steps.map((step, i) => (i === index ? { ...step, ...patch } : step))
    onChange(next)
  }

  const add = () => onChange([...steps, { step: 'strip_prefix', text: '' }])
  const remove = (index) => onChange(steps.filter((_, i) => i !== index))

  const move = (index, by) => {
    const target = index + by
    if (target < 0 || target >= steps.length) return
    const next = [...steps]
    const [moved] = next.splice(index, 1)
    next.splice(target, 0, moved)
    onChange(next)
  }

  const fieldsFor = (name) => NAME_STEPS.find((s) => s.value === name)?.fields || []

  return (
    <div>
      <If condition={!steps.length}>
        <div className="text-sm text-gray-500 mb-3">
          Names go to the partner exactly as they are stored. Add a step to change them.
        </div>
      </If>

      <For each="step" index="index" of={steps}>
        <div className="name-step" key={index}>
          <Select
            useReactSelect
            name="step"
            label={index === 0 ? 'Step' : ''}
            value={{
              value: step.step,
              label: NAME_STEPS.find((s) => s.value === step.step)?.label || step.step,
            }}
            options={NAME_STEPS.map((s) => ({ value: s.value, label: s.label }))}
            onChange={(option, name, val) => update(index, { step: val })}
            disabled={disabled}
          />

          <div className="name-step__fields">
            <For each="field" of={fieldsFor(step.step)} index="fieldIndex">
              <Input
                key={field}
                name={field}
                label={index === 0 ? FIELD_LABELS[field] || field : ''}
                value={String(step[field] ?? '')}
                onChange={(val) => update(index, { [field]: val })}
                disabled={disabled}
              />
            </For>
          </div>

          <div className="flex gap-1">
            <Button
              theme={BUTTON_THEME.SECONDARY}
              onClick={() => move(index, -1)}
              disabled={disabled || index === 0}
            >
              ↑
            </Button>
            <Button
              theme={BUTTON_THEME.SECONDARY}
              onClick={() => move(index, 1)}
              disabled={disabled || index === steps.length - 1}
            >
              ↓
            </Button>
            <Button onClick={() => remove(index)} disabled={disabled}>
              <Icon width="12px" height="12px" icon="delete" type="fill" />
            </Button>
          </div>
        </div>
      </For>

      <Button theme={BUTTON_THEME.SECONDARY} onClick={add} disabled={disabled}>
        Add a step
      </Button>
    </div>
  )
}

export default NameChanges
